import { render, staticRenderFns } from "./InstallationsSideview.vue?vue&type=template&id=3f822350&scoped=true&class=fill-height&"
import script from "./InstallationsSideview.vue?vue&type=script&lang=ts&"
export * from "./InstallationsSideview.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsSideview.vue?vue&type=style&index=0&id=3f822350&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f822350",
  null
  
)

export default component.exports